'use strict';

import React, { Component } from "react";
import ReactDOM from "react-dom";
import { RouteResults } from '../Search';
import GtfsApi from '../includes/GtfsApi';
import PicsApi from '../includes/PicsApi';
import getGeocoder from '@opentripplanner/geocoder';
import { IntlProvider } from "react-intl";
import { getSwiftIconForRoute, updateSwiftStop } from "../includes/SearchSwiftIcons";
import { getRouteChangeElement, getRouteChangeType, routeChangeType } from "../includes/Utilities.js";
// ctspritepath is located in CTBase.cshtml file

const defaultCenter = [47.903627, -122.109133];
const defaultFocusPoint = {
    "lat": 47.975725,
    "lon": -122.198705
};
const defaultZoom = 11;
const searchThrottle = 300;
let searchThrottleTimeout = null;
const routeTrackerRefresh = 15000;
let routeTrackerRefreshTimeout = null;
const stopTrackerRefresh = 15000;
let stopTrackerRefreshTimeout = null;
let filteredCount = 0;

const messages = {
    'en': {
        'otpUi.LocationField.beingTypingPrompt': 'Begin typing to search for locations',
        'otpUi.LocationField.clearLocation': 'Clear location',
        'otpUi.LocationField.currentLocationUnavailable': 'Current location not available',
        'otpUi.LocationField.fetchingLocation': 'Fetching location...',
        'otpUi.LocationField.geocoderUnreachable': 'Could not reach geocoder',
        'otpUi.LocationField.myPlaces': 'My Places',
        'otpUi.LocationField.nearby': 'Nearby Stops',
        'otpUi.LocationField.noResultsFound': 'No results found',
        'otpUi.LocationField.other': 'Other',
        'otpUi.LocationField.recentlySearched': 'Recently Searched',
        'otpUi.LocationField.stations': 'Stations',
        'otpUi.LocationField.stops': 'Stops',
        'otpUi.LocationField.useCurrentLocation': 'Use Current Location'
    }
};

const systemWideMapUrl = "system-wide-map";

class MapsAndSchedulesHeader extends Component {
    constructor(props) {
        super(props);
        this.state = props;

        window.addEventListener('storage', () => {
            this.setState(getState());
        });
    }

    _setState = (state) => {
        setState({
            ...this.state,
            ...state
        });
    };

    render() {
        return (
            <div id="maps-and-schedules-header">
                <div id="maps-and-schedules-header-container">
                    <div id="maps-and-schedules-header-left">
                        <svg role="img" aria-label="Maps & Schedules"><use xlinkHref={ctspritepath + '#maps-schedules'}></use></svg>
                        <h1>Maps & Schedules</h1>
                    </div>
                </div>
            </div>
        );
    }
}

class MapsAndSchedulesByRouteHeader extends Component {
    constructor(props) {
        super(props);
        this.state = props;

        window.addEventListener('storage', () => {
            this.setState(getState());
        });
    }

    _setState = (state) => {
        setState({
            ...this.state,
            ...state
        });
    };

    render() {
        return (
            <div id="maps-and-schedules-header">
                <div id="maps-and-schedules-header-container">
                    <div id="maps-and-schedules-header-left">
                        <svg role="img" aria-label="Maps & Schedules"><use xlinkHref={ctspritepath + '#maps-schedules'}></use></svg>
                        <h1>View all Maps & Schedules by Route</h1>
                    </div>
                </div>
            </div>
        );
    }
}

class MapsAndSchedulesFilter extends Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.state = props;

        window.addEventListener('storage', () => {
            this.setState(getState());
        });
    }

    //if there is a filter value in session storage, set it to the input field on component mount and update state
    componentDidMount = () => {
        try {
            if (sessionStorage.getItem('MapRouteId'))
            {
                const filterValue = JSON.parse(sessionStorage.getItem('MapRouteId'));
                if (this.input && this.input.current && filterValue) {
                    this.input.current.value = filterValue;
                }
                this._setState({
                    filter: filterValue
                });
            }     
        } catch (error) {
            sessionStorage.removeItem('MapRouteId');
        }       
    };

    _setState = (state) => {
        setState({
            ...this.state,
            ...state
        });
    };

    clearFilter = (e) => {
        if (this.input && this.input.current) {
            this.input.current.value = '';
        }

        this._setState({
            filter: ''
        });
        document.getElementById('maps-and-schedules-results').classList.add('show-all');
        sessionStorage.removeItem('MapRouteId');
    };

    setFilter = (e) => {
        this._setState({
            filter: e.target.value
        });
        document.getElementById('maps-and-schedules-results').classList.add('show-all');
        sessionStorage.setItem('MapRouteId', JSON.stringify(e.target.value));
    };

    render() {
        return (
            <div id="maps-and-schedules-filter">
                <div id="maps-and-schedules-filter-field">
                    <input type="text" placeholder="Filter by route number" ref={this.input} autocomplete="off" onKeyUp={this.setFilter} aria-label={getFilteredCount() + ' route' + (getFilteredCount() != 1 ? 's' : '')} />
                    {this.state.filter ? (
                        <svg role="img" aria-label="Clear Filter" onClick={this.clearFilter}><use xlinkHref={ctspritepath + '#close'}></use></svg>
                    ) : null}
                </div>
            </div>
        );
    }
}

class MapsAndSchedulesResults extends Component {
    constructor(props) {
        super(props);
        this.state = props;

        window.addEventListener('storage', () => {
            this.setState(getState());
        });
    }

    _setState = (state) => {
        setState({
            ...this.state,
            ...state
        });
    };

    componentDidMount = () => {
        const updatedRoutes = _routes.map(route => {
            const routeType = getRouteChangeType(route.route_id);

            let routeClass = '';

            if (routeType === routeChangeType.REPLACED_ROUTE) {
                routeClass = 'warning';
            }
            else if (routeType === routeChangeType.UPCOMING_ROUTE) {
                routeClass = 'information';
            }

            return {
                ...route,
                hasAlert: routeType !== routeChangeType.NO_CHANGE,
                routeType: routeType,
                routeClass: routeClass
            };
        });

        this._setState({
            routes: updatedRoutes
        });
    };

    componentDidUpdate = () => {
        if (this.state) {
            if (_previewinfo && _previewinfo.offerPreview) {
                const ctas = document.querySelectorAll('.service-change .banner-text');

                if (ctas && ctas.length) {
                    ctas.forEach(cta => {
                        cta.innerHTML = cta.innerHTML.replaceAll('[DATE]', GtfsApi.formatServiceDateAsLongDate(_previewinfo.ct_service_start_date));
                        cta.innerHTML = cta.innerHTML.replaceAll('[MONTH]', GtfsApi.formatServiceDateAsMonth(_previewinfo.ct_service_start_date));

                        if (this.state.isPreview) {
                            cta.parentElement.style.setProperty('display', (cta.parentElement.classList.contains('service-change-preview') ? 'flex' : 'none'), 'important');
                        } else {
                            cta.parentElement.style.setProperty('display', (cta.parentElement.classList.contains('service-change-preview') ? 'none' : 'flex'), 'important');
                        }
                    });
                }
            }
        }
    };

    changeTimezone = (date, ianatz) => {
        var invdate = new Date(date.toLocaleString('en-US', {
            timeZone: ianatz
        }));

        var diff = date.getTime() - invdate.getTime();

        return new Date(date.getTime() - diff);
    };

    calculateTrips = (tt) => {
        let routeShape = null;

        if (tt.routeDirection) {
            let shapeSchedules = [];

            if (tt.routeShapeSchedules && tt.routeShapeSchedules.length) {
                const direction = tt.routeShapeSchedules.find(d => d.direction_id == tt.routeDirection);

                if (direction) {
                    shapeSchedules = direction.trip;
                }
            }

            if (shapeSchedules && shapeSchedules.length) {
                if (!tt.routeShape || tt.routeShape.trip_id != shapeSchedules[0].trip_id) {
                    GtfsApi.getShapes(shapeSchedules[0].trip_id)
                        .then(response => response.json())
                        .then(result => {
                            if (result && !result.status && result.length) {
                                let shapes = [];
                                let boundMinLat = null;
                                let boundMinLon = null;
                                let boundMaxLat = null;
                                let boundMaxLon = null;

                                result.forEach((shape, shapeIndex) => {
                                    if (shapeIndex) {
                                        shapes.push([[result[shapeIndex - 1].shape_pt_lat, result[shapeIndex - 1].shape_pt_lon], [shape.shape_pt_lat, shape.shape_pt_lon]]);
                                    }

                                    if (boundMinLat === null || shape.shape_pt_lat > boundMinLat) {
                                        boundMinLat = shape.shape_pt_lat;
                                    }
                                    if (boundMinLon === null || shape.shape_pt_lon < boundMinLon) {
                                        boundMinLon = shape.shape_pt_lon;
                                    }
                                    if (boundMaxLat === null || shape.shape_pt_lat < boundMaxLat) {
                                        boundMaxLat = shape.shape_pt_lat;
                                    }
                                    if (boundMaxLon === null || shape.shape_pt_lon > boundMaxLon) {
                                        boundMaxLon = shape.shape_pt_lon;
                                    }
                                });

                                tt.routeShape = {
                                    shapes: shapes,
                                    shapeBoundMin: [boundMinLat, boundMinLon],
                                    shapeBoundMax: [boundMaxLat, boundMaxLon],
                                    trip_id: shapeSchedules[0].trip_id
                                };

                                sessionStorage.setItem('TransitTracker', JSON.stringify(tt));
                                window.dispatchEvent(new Event('storage'));
                            }
                        })
                        .catch(error => {

                        });
                }
            }
        }
    };

    callApi = (tt) => {
        let now = this.changeTimezone(new Date(), "America/Los_Angeles"),
            today = new Date(new Date(new Date(now.setHours(0)).setMinutes(0)).setSeconds(0)),
            weekday = Math.round(+(today.getDay() != 0 && today.getDay() != 6 ? today : new Date(today).setDate(today.getDate() + 2)) / 1000);

        PicsApi.getScheduleByRoute(tt.route, 1440, weekday)
            .then(response => response.json())
            .then(results => {
                let schedules = [];

                if (results && results.mode && results.mode.length) {
                    results.mode.forEach(mode => {
                        if (mode && mode.route && mode.route.length) {
                            const route = mode.route.find(r => r.route_id == tt.route);

                            if (route && route.direction && route.direction.length) {
                                schedules = route.direction;
                            }
                        }
                    });
                }

                tt.routeShapeSchedules = schedules;

                this.calculateTrips(tt);
            })
            .catch(error => {
                tt.routeShapeSchedules = [];

                this.calculateTrips(tt);
            });
    }

    redirect = (e, route) => {
        if (route && route.route_id) {
            const currentUrl = location.pathname;
            
            let ttm = document.getElementById('transit-tracker-map-root'),
                fil = document.getElementById('maps-and-schedules-filter');

            if (ttm) {
                let p = e.target.closest('.accordion-card'),
                    open = false;
                if (p) {
                    open = p.classList.toggle('selected');
                }
                if (!open) {
                    p.parentNode.classList.add('show-all');
                    
                    //check current url contains system-wide-map and last part of url is not system-wide-map (contains routeid)
                    if (currentUrl.includes(systemWideMapUrl) && currentUrl.substring(currentUrl.lastIndexOf("/") + 1) !== systemWideMapUrl) {
                        //remove route id from url
                        history.replaceState({}, '', currentUrl.substring(0, currentUrl.lastIndexOf("/")));
                    }
                }

                else {
                    p.parentNode.classList.remove('show-all');

                    //user interacted with card - append route id to url
                    //check current url contains system-wide-map and last part of url is not system-wide-map (contains routeid)
                    if (currentUrl.includes(systemWideMapUrl) && currentUrl.substring(currentUrl.lastIndexOf("/") + 1) !== systemWideMapUrl) {
                        const urlToPush = currentUrl.substring(0, currentUrl.lastIndexOf("/")) + `/${encodeURIComponent(route.route_id)}`;
                        history.replaceState({}, '', urlToPush);
                    } else {
                        const urlToPush = currentUrl + `/${encodeURIComponent(route.route_id)}`;
                        history.replaceState({}, '', urlToPush);
                    }

                    for (let sib of p.parentNode.children) {
                        if (sib !== p) sib.classList.remove('selected');
                    }
                    ttm.classList.remove('d-none');

                    setTimeout(() => {
                        if (p.parentNode.offsetHeight < 200) {
                            window.scrollTo({
                                behavior: 'smooth',
                                top:
                                    fil.getBoundingClientRect().top -
                                    document.body.getBoundingClientRect().top -
                                    20,
                            })
                        }
                    }, 300);

                    let tt = sessionStorage.getItem('TransitTracker');

                    if (tt) {
                        tt = JSON.parse(tt);
                        tt.route = route.route_id;
                        tt.setBounds = true;

                        this.callApi(tt);
                    }
                }
            }
            else {
                e.stopPropagation();

                location.href = '/route/' + encodeURIComponent(route.route_id) + '/table' + (this.state.isPreview ? '/preview' : '');
            }
        }
    };

    isRouteClickable = (route) => {
        const isPreview = this.state.isPreview === true ? true : false;
        const isReplacedRoute = route.routeType === routeChangeType.REPLACED_ROUTE;

        return !(isPreview && isReplacedRoute);
    }

    renderRouteContent = (route) => {
        const icon = getSwiftIconForRoute(route.route_id);

        return (
            <>
                <div class="maps-and-schedules-route-name-container">
                    {icon ? (
                        <img class="maps-and-schedules-route-icon" src={icon} alt={route.route_name} />
                    ) : null}
                    <h5>{route.route_short_name}</h5>
                </div>
                <div class="maps-and-schedules-route-name">{route.route_name}</div>
                {route.hasAlert ? (getRouteChangeElement(route.route_id, false)) : null}
            </>
        )
    }

    render() {
        let { routes, filter } = this.state,
            flat = !document.getElementById('transit-tracker-map-root') ? true : false;
        if (this.state.filter) {
            routes = routes.map(route => {
                route.filtered = true;
                if (route.route_id.includes(this.state.filter)
                    || route.route_name.toLowerCase().includes(this.state.filter.toLowerCase())
                    || route.route_short_name.toLowerCase().includes(this.state.filter.toLowerCase())) {
                    route.filtered = false;
                }
                return route;
            });
        }
        else {
            routes = routes.map(r => { r.filtered = false; return r; });
        }

        routes.sort((a, b) => {
            let bb = b.route_short_name,
                aa = a.route_short_name;
            if (!isNaN(parseFloat(bb[0])) && !isNaN(parseFloat(aa[0]))) {
                return aa.localeCompare(bb, undefined, { numeric: true });
            }
            return bb[0].localeCompare(aa[0]);
        });

        if (_previewinfo && _previewinfo.offerPreview && !this.state.isPreview && upcomingRoutes && upcomingRoutes.length) {
            routes = routes.filter(r => !upcomingRoutes.includes(r.route_id));
        }

        return (
            <ul id="maps-and-schedules-results" class="un-list accordion show-all" role="list " aria-label={filteredCount + ' route' + (filteredCount != 1 ? 's' : '')}>
                {routes.map((route, i) => {
                    return (
                        <li class={"maps-and-schedules-route card accordion-card" + (route.filtered ? ' filtered' : '')} data-routeidcard={route.route_id}>
                            <div class={"card-header" + (route.hasAlert ? ' card-header-alert' : '') + ' ' + route.routeClass} id={"heading" + i}>
                                <div class="accordion-header mb-0">
                                    {this.isRouteClickable(route) ? 
                                        <button onClick={e => { this.redirect(e, route); }} class="btn btn-link btn-block text-left collapsible-link" aria-controls={"collapse" + i} data-toggle="collapse" data-target={flat ? "" : "#collapse" + i} aria-expanded="false" data-routeid={route.route_id}>
                                            {this.renderRouteContent(route)}
                                        </button>
                                        :
                                        <div class="unclickable-route">
                                            {this.renderRouteContent(route)}
                                        </div>
                                    }
                                </div>
                                <div id={"collapse" + i} aria-labelledby={"heading" + i} class="collapse" data-parent="#maps-and-schedules-results">
                                    <a href={"/route/" + route.route_id}>More info</a>
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

class MapsAndSchedulesSearch extends Component {
    constructor(props) {
        super(props);
        this.input = React.createRef();
        this.state = props;

        window.addEventListener('storage', () => {
            this.setState(getState());
        });
    }

    componentDidMount = () => {
        if (_previewinfo && _previewinfo.offerPreview) {
            const ctas = document.querySelectorAll('.service-change .banner-text');

            if (ctas && ctas.length) {
                ctas.forEach(cta => {
                    cta.innerHTML = cta.innerHTML.replaceAll('[DATE]', GtfsApi.formatServiceDateAsLongDate(_previewinfo.ct_service_start_date));
                    cta.innerHTML = cta.innerHTML.replaceAll('[MONTH]', GtfsApi.formatServiceDateAsMonth(_previewinfo.ct_service_start_date));
                    cta.parentElement.style.setProperty('display', 'flex', 'important');
                });
            }
        }
    }

    componentDidUpdate = () => {
        if (this.state) {
            if (this.state.redirect) {
                this.redirect();
            }
        }
    };

    _setState = (state) => {
        setState({
            ...this.state,
            ...state
        });
    };

    getRouteEndpoint = (isStart) => {
        if (this.state.route && this.state.routeDirection && this.state.routeStops && this.state.routeStops.length) {
            const direction = this.state.routeStops.find(d => d.direction_id == this.state.routeDirection);

            if (direction && direction.stop && direction.stop.length) {
                return direction.stop[isStart ? 0 : direction.stop.length - 1].stop_name;
            }
        }

        return '';
    };

    onSearchBlur = (e) => {
        if (e.relatedTarget === null || !document.getElementById('maps-and-schedules-search-results').contains(e.relatedTarget)) {
            /*
            this._setState({
                autocomplete: false
            });
            */
        }
    };

    onSearchChange = (e) => {
        if (searchThrottleTimeout) {
            clearTimeout(searchThrottleTimeout);
        }

        const query = e.target.value;

        if (query) {
            searchThrottleTimeout = setTimeout(() => {
                let routes = [];
                let stops = [];

                _routes.forEach(route => {
                    if (route.route_id.includes(query) || route.route_name.toLowerCase().includes(query.toLowerCase()) || route.route_short_name.toLowerCase().includes(query.toLowerCase())) {
                        routes.push(route);
                    }
                });

                _stops.forEach(stop => {
                    if (stop.stop_id.includes(query) || stop.stop_name.toLowerCase().includes(query.toLowerCase())) {
                        stops.push(stop);
                    }
                });

                if (stops && stops.length) {
                    const parentIds = stops.filter(s => s.parent_station).map(s => s.parent_station);

                    if (parentIds.length) {
                        parentIds.forEach(parentId => {
                            const parent = stops.find(s => s.stop_id == parentId);

                            if (parent) {
                                stops = stops.filter(s => s.parent_station != parentId);
                            }
                        });
                    }
                }

                //update stop properties with swift specific icons if applicable
                stops = stops.map(stop => updateSwiftStop(stop));

                routes.sort((a, b) => a.route_id - b.route_id);
                stops.sort((a, b) => a.stop_id - b.stop_id);

                getGeocoder({
                    "baseUrl": (typeof otpGeocoderUrl !== 'undefined' && otpGeocoderUrl) || "https://im5b1wfh6d.execute-api.us-east-1.amazonaws.com/commtrans",
                    "boundary": {
                        "rect": {
                            "maxLat": 48.687912,
                            "maxLon": -121.467028,
                            "minLat": 46.981852,
                            "minLon": -123.148723
                        }
                    },
                    "focusPoint": defaultFocusPoint,
                    "options": {
                        "headers": {
                            "x-api-key": "wCriD1G1Hx2y19liJRj6B4LqobOn2hc14DadI15T"
                        }
                    },
                    "maxNearbyStops": 6,
                    "type": "PELIAS"
                }).autocomplete({
                    text: query
                }).then(result => {
                    let addresses = [];

                    if (result && result.features && result.features.length) {
                        result.features.forEach(feature => {
                            if (!feature.properties || feature.properties.layer !== 'stops') {
                                addresses.push(feature);
                            }
                        });
                    }

                    this._setState({
                        addresses
                    });
                }).catch(error => {
                    this._setState({
                        addresses: []
                    });
                });

                this._setState({
                    addresses: [],
                    autocomplete: true,
                    query,
                    routes,
                    stops
                });
            }, searchThrottle);
        } else {
            this._setState({
                addresses: [],
                autocomplete: true,
                query,
                routes: [],
                stops: []
            });
        }
    };

    onSearchFocus = (e) => {
        setTimeout(() => {
            var el = document.querySelector('#transit-tracker-search-results');
            if (el && !isScrolledIntoView(el, 300)) {
                scrollIntoViewWithOffset(el, 200);
            }
        });

        this._setState({
            autocomplete: true
        });
    };

    handleLocation = (e, type, data = null) => {
        e.preventDefault();

        if (type == 'address' && data) {
            this._setState({
                autocomplete: false,
                location: {
                    lat: data.geometry.coordinates[1],
                    lon: data.geometry.coordinates[0],
                    name: data.properties.label.replace(', United States', '')
                },
                query: data.properties.label.replace(', United States', ''),
                redirect: true,
                route: null,
                stop: null
            });
        } else if (type == 'current') {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this._setState({
                            autocomplete: false,
                            currentPosition: {
                                coords: {
                                    latitude: position.coords.latitude,
                                    longitude: position.coords.longitude
                                }
                            },
                            location: {
                                lat: position.coords.latitude,
                                lon: position.coords.longitude,
                                name: 'Current Location'
                            },
                            query: '(Current Location)',
                            redirect: true,
                            route: null,
                            stop: null
                        });
                    },
                    error => {
                        this._setState({
                            autocomplete: false,
                            currentPosition: null,
                            location: null,
                            route: null,
                            stop: null
                        });
                    }
                );
            }
        } else if (type == 'route' && data) {
            this._setState({
                autocomplete: false,
                location: null,
                query: data.route_short_name + ' - ' + data.route_name,
                redirect: true,
                route: data.route_id,
                stop: null
            });
        } else if (type == 'stop' && data) {
            let isParent = false;

            if (_stops && _stops.length) {
                isParent = (_stops.filter(s => s.parent_station == data.stop_id).length > 0);
            }

            this._setState({
                autocomplete: false,
                location: null,
                query: (!isParent ? data.stop_id + ' - ' : '') + data.stop_name,
                redirect: true,
                route: null,
                stop: data.stop_id
            });
        }
    };

    redirect = () => {
        if (this.input && this.input.current) {
            this.input.current.value = this.state.query;
        }

        this._setState({
            redirect: false
        });

        if (this.state.location) {
            location.href = '/address/' + encodeURIComponent(this.state.location.lat + ',' + this.state.location.lon) + '/' + encodeURIComponent(this.state.location.name.replace(' & ', ' and ').replace('&', '|and|'));
        } else if (this.state.route) {
            location.href = '/route/' + encodeURIComponent(this.state.route) + '/table';
        } else if (this.state.stop) {
            location.href = '/stop/' + encodeURIComponent(this.state.stop) + '/schedule';
        }
    };

    toggleRouteDirection = () => {
        const direction = (this.state.routeDirection == '0' ? '1' : '0');

        updateUrl('route', {
            route: this.state.route,
            routeDirection: direction,
            view: this.state.view
        });

        this._setState({
            callApi: 'route_trips',
            routeDirection: direction
        });
    };

    toggleShow = (e, param) => {
        e.preventDefault();

        let state = {};
        state[param] = !this.state[param];

        this._setState(state);
    };

    updateUrl = (type, data = null) => {

    };

    render() {
        return (
            <>
                <div class={'transit-tracker-favorites-link' + (isFavorite() ? ' transit-tracker-favorites-link-favorited' : '')}>
                    <a href="/favorites">
                        <svg role="img" aria-label="Favorite">
                            <use xlinkHref={ctspritepath + '#favorite'}></use>
                        </svg>
                        View All Favorites
                    </a>
                </div>
                <div id="transit-tracker-search">
                    <p>Find maps and schedules for stops and routes</p>
                    <div id="transit-tracker-search-field">
                        <svg role="img" aria-label="End">
                            <use xlinkHref={ctspritepath + '#location-outline'}></use>
                        </svg>
                        <label htmlFor="maps-and-schedules-search-input" className="sr-only">
                            Search for a stop, route, or location
                        </label>
                        <input id="maps-and-schedules-search-input" type="text" placeholder="Enter stop, route, or location" ref={this.input}
                               autocomplete="off" onFocus={this.onSearchFocus} onBlur={this.onSearchBlur}
                               onKeyUp={this.onSearchChange}/>
                    </div>
                    {this.state.autocomplete ? (
                        <div id="transit-tracker-search-results">
                            <ul>
                                <li>
                                    <svg role="img" aria-label="Nearby"><use xlinkHref={ctspritepath + '#gps-16'}></use></svg>
                                    <a href="#" onClick={(e) => this.handleLocation(e, 'current')}>Find nearby routes and stops</a>
                                </li>
                            </ul>
                            <RouteResults
                                query={this.state.query}
                                routes={this.state.routes}
                                showAll={this.state.routesShowAll}
                                onRouteClick={this.handleLocation}
                                onShowAllClick={this.toggleShow} />
                            {this.state.query && this.state.stops.length ? (
                                <>
                                    <h3>Stops</h3>
                                    <ul>
                                        {this.state.stops.slice(0, (!this.state.stopsShowAll ? 3 : this.state.stops.length)).map(stop => {
                                            let isParent = false;

                                            if (_stops && _stops.length) {
                                                isParent = (_stops.filter(s => s.parent_station == stop.stop_id).length > 0);
                                            }

                                            return ( 
                                                <li>
                                                    <div class="d-flex transit-tracker-search-stop-container">
                                                        <span className="transit-tracker-search-stop-name">
                                                            <svg role="img" aria-label="Stop">
                                                                <use xlinkHref={ctspritepath + '#starting-point-16'}></use>
                                                            </svg>
                                                            <a href="#" onClick={(e) => this.handleLocation(e, 'stop', stop)}>{!isParent ? <span>{stop.stop_id}</span> : null}{(!isParent ? ' - ' : '') + stop.stop_name}</a>
                                                        </span>
                                                        {stop.isSwift ?
                                                        stop.icons.map(icon => <img class="transit-tracker-search-swift-stop-icon" src={icon} alt={icon}/>) 
                                                        : null}
                                                    </div>
                                                </li>
                                            );
                                        })}
                                        {this.state.stops.length > 3 ? (
                                            <li><a href="#" onClick={(e) => this.toggleShow(e, 'stopsShowAll')}>Show {this.state.stopsShowAll ? 'less' : 'all'}</a></li>
                                        ) : null}
                                    </ul>
                                </>
                            ) : null}
                            {this.state.query && this.state.addresses.length ? (
                                <>
                                    <h3>Addresses</h3>
                                    <ul>
                                        {this.state.addresses.slice(0, (!this.state.addressesShowAll ? 3 : this.state.addresses.length)).map(address => {
                                            return (
                                                <li><svg role="img" aria-label="Address"><use xlinkHref={ctspritepath + '#location-16'}></use></svg><a href="#" onClick={(e) => this.handleLocation(e, 'address', address)}>{address.properties.label.replace(', United States', '')}</a></li>
                                            );
                                        })}
                                        {this.state.addresses.length > 3 ? (
                                            <li><a href="#" onClick={(e) => this.toggleShow(e, 'addressesShowAll')}>Show {this.state.addressesShowAll ? 'less' : 'all'}</a></li>
                                        ) : null}
                                    </ul>
                                </>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </>
        );
    }
}


function getState() {
    if (sessionStorage.getItem('MapsAndSchedules')) {
        return JSON.parse(sessionStorage.getItem('MapsAndSchedules'));
    }

    return null;
}

function setState(state) {
    sessionStorage.setItem('MapsAndSchedules', JSON.stringify(state));
    window.dispatchEvent(new Event('storage'));
}

let cachedState = getState();
let isPreview = location.search && location.search.toLowerCase().includes('preview');

if (cachedState) {
    cachedState.filter = '';
    cachedState.routes = [];
    cachedState.route = '';
    cachedState.autocomplete = false;
    cachedState.query = '';
    cachedState.isPreview = isPreview;
    setState(cachedState);
} else {
    setState({
        filter: '',
        routes: [],
        route: '',
        query: '',
        autocomplete: false,
        isPreview: isPreview
    });
}


function isFavorite() {
    const favState = getFavState();
    const state = getState();

    if (favState.favorites && (
        (location.pathname.startsWith('/address/') && favState.favorites.find(r => r.id == btoa(location.pathname) && r.type == 'address')) ||
        (location.pathname.startsWith('/route/') && favState.favorites.find(r => r.id == state.route && r.type == 'route')) ||
        (location.pathname.startsWith('/stop/') && favState.favorites.find(r => r.id == state.stop && r.type == 'stop'))
    )) {
        return true;
    }

    return false;
}

let cachedFavState = getFavState();

if (cachedFavState) {
    if (!cachedFavState.favorites) {
        cachedFavState.favorites = [];
    }

    setFavState(cachedFavState);
} else {
    setFavState({
        favorites: []
    });
}

function getFavState() {
    if (localStorage.getItem('Favorites')) {
        return JSON.parse(localStorage.getItem('Favorites'));
    }

    return {
        favorites: []
    };
}

function setFavState(state) {
    localStorage.setItem('Favorites', JSON.stringify(state));
    window.dispatchEvent(new Event('storage'));
}

function getFilteredCount() {
    let state = getState();
    let { routes, filter } = state,
        flat = !document.getElementById('transit-tracker-map-root') ? true : false;
    filteredCount = 0;
    if (state.filter) {
        routes = routes.map(route => {
            route.filtered = true;
            if (route.route_id.includes(state.filter)
                || route.route_name.toLowerCase().includes(state.filter.toLowerCase())
                || route.route_short_name.toLowerCase().includes(state.filter.toLowerCase())) {
                route.filtered = false;
                filteredCount++;
            }
        });
    }
    else {
        filteredCount = routes.length;
    }
    return filteredCount;
}



if (document.getElementById('maps-and-schedules-header-root')) {
    ReactDOM.render(
        <MapsAndSchedulesHeader {...getState()} />,
        document.getElementById('maps-and-schedules-header-root')
    );
}

if (document.getElementById('maps-and-schedules-by-route-header-root')) {
    ReactDOM.render(
        <MapsAndSchedulesByRouteHeader {...getState()} />,
        document.getElementById('maps-and-schedules-by-route-header-root')
    );
}

if (document.getElementById('maps-and-schedules-filter-root')) {
    ReactDOM.render(
        <MapsAndSchedulesFilter {...getState()} />,
        document.getElementById('maps-and-schedules-filter-root')
    );
}

if (document.getElementById('maps-and-schedules-search-root')) {
    ReactDOM.render(
        <IntlProvider locale="en" messages={messages.en}><MapsAndSchedulesSearch {...getState()} /></IntlProvider>,
        document.getElementById('maps-and-schedules-search-root')
    );
}

if (document.getElementById('maps-and-schedules-results-root')) {
    ReactDOM.render(
        <MapsAndSchedulesResults {...getState()} />,
        document.getElementById('maps-and-schedules-results-root')
    );
}

//expand route card if route id is in url and focus map on route
document.addEventListener("DOMContentLoaded", (event) => {
    if (location.pathname.includes(systemWideMapUrl))
        {
            const routeInPath = location.pathname.substring(location.pathname.lastIndexOf("/") + 1);
            if (routeInPath && routeInPath !== systemWideMapUrl) {
                const routeCardNode = document.querySelector(`[data-routeidcard="${routeInPath}"]`);
                    if (routeCardNode && !routeCardNode.classList.contains("selected")) {
                        document.querySelector(`[data-routeid="${routeInPath}"]`)?.click();    
                    }     
            } 
        } 
});